import React from "react";
import { Table, Button } from "reactstrap";
import { Link } from "react-router-dom";

const TableCompany = (props) => {
  const styles = {
    tableHead: {
      paddingTop: "2vh",
      fontSize: "1em",
      textTransform: "capitalize",
      color: "#2c2a2a",
      borderTop: "none",
    },
  };
  return (
    <Table className="align-items-center" hover responsive>
      <thead>
        <tr>
          {props.header?.map((item, index) => (
            <th style={styles.tableHead} key={index}>
              {item}
            </th>
          ))}
        </tr>
      </thead>
      <tbody>
        {props.searchedData?.map((data) => (
          <tr style={{ color: "#6C6C6C" }} key={data._id}>
            <td>
              <span>{data.name}</span>
            </td>
            <td>{data.email}</td>
            <td>
              <Link
                to={`/admin/companies/${data._id}/logs`}
                style={{
                  textDecoration: "underline",
                  color: "#6C6C6C",
                }}
                className="pr-4"
              >
                <span>VIEW LOGS</span>
              </Link>
              <Link to={`/admin/companies/${data._id}/edit`}>
                <Button color="secondary" outline type="button">
                  EDIT
                </Button>
              </Link>
            </td>
          </tr>
        ))}
      </tbody>
    </Table>
  );
};

export default TableCompany;
